export default "__VITE_ASSET__1ee91b04__"